export const SEC_LINK_REPOSITORY = {
  '0011':
    'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=S000002233&type=n-mfp&dateb=&count=40&scd=filings',
  '0062':
    'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0000783401&type=N-MFP&dateb=&count=40&scd=filings',
  '0045':
    'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=S000002898&type=N-MFP&dateb=&count=40&scd=filings',
  '0095':
    'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0000821404&type=N-MFP&dateb=&count=40&scd=filings',
  '0163':
    'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0000788599&type=N-MFP&dateb=&count=40&scd=filings',
  '0063':
    'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK=0000788606&type=n-mfp&dateb=&count=40&scd=filings',
  '0030':
    'https://www.sec.gov/cgi-bin/browse-edgar?CIK=vmmxx&owner=exclude&action=getcompany',
  '0066':
    'https://www.sec.gov/cgi-bin/browse-edgar?CIK=vmrxx&owner=exclude&action=getcompany',
  '0033':
    'https://www.sec.gov/cgi-bin/browse-edgar?CIK=vmfxx&owner=exclude&action=getcompany',
}
